export default __webpack_public_path__ + "images/e1a69a8af21f4b86d6ad01111b6b8d9d.png";